module.exports = __webpack_public_path__ + "img/tarj-2.419478e1.svg";